import React, { FunctionComponent, useState, useRef, useEffect } from 'react';
import useTranslate from '@hooks/useTranslate';
import componentContent from './ShowMore.module.json';
import cn from 'classnames';
import css from './ShowMore.module.less';

interface ShowMoreProps {
  height: number;
}

const ShowMore: FunctionComponent<ShowMoreProps> = ({ height, children }) => {
  const [show, setShow] = useState(false);
  const [isButtonShow, setIsButtonShow] = useState(true);
  const content = useTranslate(componentContent);
  const childRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const childHeight = childRef?.current?.offsetHeight || 0;
    if (childHeight < height) {
      setIsButtonShow(false);
    } else {
      setIsButtonShow(true);
    }
  }, [children, childRef, height]);

  return (
    <div className={css.showMore} style={{ height: show || !isButtonShow ? 'auto' : height }}>
      <span className={cn(css.showMore__text, { [css.isButtonShow]: isButtonShow })}>
        <div ref={childRef}>{children}</div>
      </span>
      {isButtonShow ? (
        <>
          <div className={css.showMore__background} hidden={show} />
          <span
            onClick={() => {
              setShow((_show) => !_show);
            }}
            className={css.showMore__button}
          >
            {show ? content.show_less : content.show_more}
          </span>
        </>
      ) : null}
    </div>
  );
};

export default ShowMore;
